export default __webpack_public_path__ + "static/media/2095.fb30931c.png";